define('glu/inputPlugins',['require','jquery','./util','./flexDropdown'],function(require) {
    'use strict';

    var $ = require('jquery'),
        util = require('./util'),
        FlexDropdown = require('./flexDropdown');

    /**
     * instantiates a data-bindable Flex Dropdown on an existing element
     * @param [options] options to pass through to the Flex Dropdown constructor 
     * @returns {this}
     */
    $.fn.flexDropdown = function(options) {
        // TODO can data binding SET the value?
        var $target = this;

        // if called with options object, build new flexdropdown
        if (util.isObject(options)) {
            if (this.data('flexDropdown')) {
                // check for existing flex dropdown and replace with the new one
                $target = this.flexDropdown('destroy');
            }

            var original = $target.clone(),
                flexDropdown = new FlexDropdown(util.extend(options, {
                    el: $target
                }));

            $target.data({
                'flexDropdown': flexDropdown,
                originalElement: original
            });

            $target.addClass(util.result(flexDropdown, 'className'));
            return $target;
        }

        // ensure one has already been created 
        if ($target.data('flexDropdown')) {
            switch (options) {
                case 'val':
                    if (arguments.length === 2) {
                        // val with a second parameter - set the value(s) by ID
                        $target.data('flexDropdown').setSelectedIds(arguments[1]);
                        break;
                    } else {
                        // return IDs of selected items
                        return $target.data('flexDropdown').value('id');
                    }
                case 'data':
                    // return objects of selected items
                    return $target.data('flexDropdown').value();
                case 'destroy':
                    // tear down flexdropdown 
                    var $original = $target.data('originalElement');
                    $original.insertBefore($target);
                    $target.data('flexDropdown').close();
                    return $original;
            }
        }

        return $target;
    };

    return $;
});

